import { html } from 'lit';

export const iconEye = html`
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.87891 4.15234C7.96094 4.15234 8.04297 4.125 8.125 4.125C9.57422 4.125 10.75 5.30078 10.75 6.75C10.75 8.19922 9.57422 9.375 8.125 9.375C6.64844 9.375 5.5 8.19922 5.5 6.75C5.5 6.69531 5.5 6.61328 5.5 6.53125C5.74609 6.66797 6.04688 6.75 6.375 6.75C7.33203 6.75 8.125 5.98438 8.125 5C8.125 4.69922 8.01562 4.39844 7.87891 4.15234ZM13.375 2.83984C14.6602 4.01562 15.5078 5.4375 15.918 6.42188C16 6.64062 16 6.88672 15.918 7.10547C15.5078 8.0625 14.6602 9.48438 13.375 10.6875C12.0898 11.8906 10.3125 12.875 8.125 12.875C5.91016 12.875 4.13281 11.8906 2.84766 10.6875C1.5625 9.48438 0.714844 8.0625 0.304688 7.10547C0.222656 6.88672 0.222656 6.64062 0.304688 6.42188C0.714844 5.4375 1.5625 4.01562 2.84766 2.83984C4.13281 1.63672 5.91016 0.625 8.125 0.625C10.3125 0.625 12.0898 1.63672 13.375 2.83984ZM8.125 2.8125C5.9375 2.8125 4.1875 4.58984 4.1875 6.75C4.1875 8.9375 5.9375 10.6875 8.125 10.6875C10.2852 10.6875 12.0625 8.9375 12.0625 6.75C12.0625 4.58984 10.2852 2.8125 8.125 2.8125Z"
    />
  </svg>
`;
